export default __webpack_public_path__ + "static/media/Fountain.8dd2124f.png";